import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { type AdminUserAddRouteModel } from '../add';
import type CachedDataset from 'donor-elf-web/services/cached-dataset';

export default class AdminUsersAddSaveRoute extends Route {
  @service declare cachedDataset: CachedDataset;
  @service declare storeCache: any;
  @service declare flashMessages: any;
  @service declare router: RouterService;

  model() {
    return this.modelFor('admin.users.add');
  }

  async afterModel(model: AdminUserAddRouteModel) {
    let { changeset } = model;
    changeset.set('fundIds', model.selectedFundIds);

    await changeset.save();
    // refresh the userFunds to get the created user funds for the user
    this.storeCache.breakFindAllCache('admin/user');
    this.storeCache.breakFindAllCache('admin/user-fund');
    this.flashMessages.success(
      'The user was created, and an email has been sent to let them know how to login.',
    );

    this.cachedDataset.forModel('admin/user').add(changeset.get('id'));
    this.router.transitionTo('admin.users.show', changeset.get('id'));
  }

  async redirect(model: AdminUserAddRouteModel) {
    await model.changeset.validate();
    if (model.changeset.get('isInvalid')) {
      this.router.transitionTo('admin.users.add');
    }
  }
}
